import { IterableX } from '../../iterable/iterablex';
import { partition } from '../../iterable/partition';

/**
 * @ignore
 */

export function partitionProto<T, S extends T>(
  this: IterableX<T>,
  predicate: (value: T, index: number) => value is S,
  thisArg?: any
): IterableX<S>[];
export function partitionProto<T>(
  this: IterableX<T>,
  predicate: (value: T, index: number) => boolean,
  thisArg?: any
): IterableX<T>[];
export function partitionProto<T>(
  this: IterableX<T>,
  predicate: (value: T, index: number) => boolean,
  thisArg?: any
): IterableX<T>[] {
  return partition(this, predicate, thisArg);
}

IterableX.prototype.partition = partitionProto;

declare module '../../iterable/iterablex' {
  interface IterableX<T> {
    partition: typeof partitionProto;
  }
}



// WEBPACK FOOTER //
// ./node_modules/ix/add/iterable-operators/partition.ts